import { createContext } from "react";

interface SelectedOptionsContextProps {
    selectedPatient: { id: number; name: string };
    setSelectedPatient: any;
    selectedInstrument: { id: number; name: string },
    setSelectedInstrument: any,
    selectedResearch: { id: number; name: string },
    setSelectedResearch: any
}

const selectedOptionsContext = createContext<SelectedOptionsContextProps>({
    selectedPatient: { id: 0, name: "" },
    setSelectedPatient: (id: number, name: string) => {
        return;
    },
    selectedInstrument: { id: 0, name: "" },
    setSelectedInstrument: (id: number, name: string) => {
        return;
    },
    selectedResearch: { id: 0, name: "" },
    setSelectedResearch: (id: number, name: string) => {
        return;
    },
});

export default selectedOptionsContext;
